import { render, staticRenderFns } from "./ProducerForm.vue?vue&type=template&id=aa7543fa&scoped=true&"
import script from "./ProducerForm.vue?vue&type=script&lang=js&"
export * from "./ProducerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa7543fa",
  null
  
)

export default component.exports